import { useMemo } from 'react'
import { Category } from '../../firebase'
import { useCategories } from './useCategories'

export const useCategory = (
  categoryId?: string,
  defaultCategory?: Category
) => {
  const { categories } = useCategories() // キャッシュから読み取る
  const category = useMemo<Category | null | undefined>(() => {
    if (categoryId === undefined || !categories) return undefined
    return categories.find((c) => c.id === categoryId) ?? null
  }, [categories, categoryId])
  return {
    category: category ?? defaultCategory,
    loading: categories === undefined,
  }
}
